import clsx from 'clsx'
import { useEffect, useId, useMemo, useRef, useState } from 'react'
import { Button, Checkbox, StackIcon } from 'shared/ui'

import {
	$contactColumns,
	$executionsColumns,
	Column,
	columnHeaders,
	Options
} from '../../utils/columns'
import css from './ColumnSettings.module.scss'

interface CN {
	className?: string
}

const initSet = () => new Set<Column>()

function ColumnSettings({
	className,
	options,
	selected
}: CN & {
	options: Column[]
	selected: typeof $contactColumns
}) {
	const id = useId()
	const [_, setRerender] = useState(0)
	const asSet = useMemo(initSet, [])
	const ref = useRef<HTMLFormElement | null>(null)

	useEffect(() => {
		const form = ref.current
		if (!ref.current) {
			return
		}
		function syncStoreWithState() {
			asSet.clear()
			for (const key of selected.get()) {
				asSet.add(key)
			}
			setRerender(prev => ++prev)
		}

		form?.addEventListener('toggle', syncStoreWithState)
	}, [selected, asSet])

	return (
		<>
			<Button
				className={clsx(css.trigger, className)}
				// @ts-ignore Recheck in React 19
				popovertarget={id}
				popovertargetaction='toggle'
				shape='square'
				variant='bordered'
			>
				<StackIcon icon='gear' width={14} />
			</Button>

			<form
				className={css.root}
				id={id}
				onSubmit={event => {
					event.preventDefault()
					const newValues = options.filter(key => asSet.has(key))

					selected.set(newValues)

					const form = event.currentTarget
					form.hidePopover()
				}}
				// @ts-ignore Recheck in React 19
				popover='auto'
				ref={ref}
			>
				<div className={css.list}>
					{options.map(key => (
						<label className={css.label} key={key}>
							<Checkbox
								checked={asSet.has(key)}
								disabled={key === Column.Contact}
								name='options'
								onChange={event => {
									event.currentTarget.checked
										? asSet.add(key)
										: asSet.delete(key)
									setRerender(prev => ++prev)
								}}
								value={key}
							/>
							{columnHeaders[key]}
						</label>
					))}
				</div>

				<Button className={css.submit} type='submit'>
					Apply
				</Button>
			</form>
		</>
	)
}

export const ColumnSettingsGeneral = ({ className }: CN) => (
	<ColumnSettings
		className={className}
		options={Options.General}
		selected={$contactColumns}
	/>
)

export const ColumnSettingsCampaign = ({ className }: CN) => (
	<ColumnSettings
		className={className}
		options={Options.Campaign}
		selected={$executionsColumns}
	/>
)
